import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

const SIGNUP_CONVERSION_PENDING_KEY = 'bpa.signupConversion.pending';

@Injectable({ providedIn: 'root' })
export class GoogleAdsService {
  private loaded = false;

  init(): void {
    const id = environment.googleAds?.conversionId;
    if (!id || this.loaded || typeof window === 'undefined') {
      return;
    }
    this.loaded = true;

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(script);

    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).gtag = function gtag() {
      (window as any).dataLayer.push(arguments);
    };
    const gtag = (window as any).gtag;

    gtag('consent', 'default', {
      ad_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
      analytics_storage: 'granted',
    });

    gtag('js', new Date());
    gtag('config', id);
  }

  markSignupConversionPending(): void {
    try {
      window.sessionStorage?.setItem(SIGNUP_CONVERSION_PENDING_KEY, '1');
    } catch {
    }
  }

  fireSignupConversionIfPending(): void {
    let pending = false;
    try {
      pending = window.sessionStorage?.getItem(SIGNUP_CONVERSION_PENDING_KEY) === '1';
      if (pending) {
        window.sessionStorage.removeItem(SIGNUP_CONVERSION_PENDING_KEY);
      }
    } catch {
    }

    if (!pending) {
      return;
    }

    const id = environment.googleAds?.conversionId;
    const label = environment.googleAds?.conversionLabel;
    const gtag = (window as any).gtag;
    if (!id || !label || typeof gtag !== 'function') {
      return;
    }

    gtag('event', 'conversion', {
      send_to: `${id}/${label}`,
      event_callback: () => {
        console.log('[GoogleAds] Signup conversion fired');
      },
    });
  }
}
